import React from "react";
import { useAssessment } from "../../context/AssessmentContext";
import { useToast } from "../ui/Toast";

export default function LeadCaptureForm({ onSubmit }) {
  const { lead, updateLead, leadCaptured, setLeadCaptured } = useAssessment();
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!lead.email || !lead.name) return;
    setLeadCaptured(true);
    toast.success(`Report sent to ${lead.email}! We'll follow up within 24 hours.`);
    if (onSubmit) onSubmit(lead);
  };

  if (leadCaptured) {
    return (
      <div className="fade-up" style={{
        padding: "28px 24px",
        background: "rgba(16,185,129,0.06)",
        border: "1px solid rgba(16,185,129,0.22)",
        borderRadius: "var(--radius-lg)",
        textAlign: "center",
      }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
        <div style={{
          fontFamily: "var(--font-display)",
          fontWeight: 700,
          fontSize: 18,
          color: "#34d399",
          marginBottom: 6,
        }}>
          Report sent to {lead.email}
        </div>
        <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
          A Ballot D.A. consultant will follow up within 24 hours with
          domain-specific recommendations.
        </div>
      </div>
    );
  }

  return (
    <div style={{
      padding: "24px",
      background: "rgba(59,130,246,0.04)",
      border: "2px solid rgba(59,130,246,0.18)",
      borderRadius: "var(--radius-lg)",
    }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{
          fontFamily: "var(--font-display)",
          fontWeight: 700,
          fontSize: 16,
          color: "#93c5fd",
          marginBottom: 4,
        }}>
          📧 Get Your Full Detailed Report
        </div>
        <p style={{ fontSize: 13, color: "var(--text-muted)" }}>
          Enter your details to receive a personalised PDF report with
          domain-specific recommendations and improvement roadmap.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 10,
          marginBottom: 12,
        }}>
          {[
            { key: "name",   label: "Full Name",   placeholder: "Jane Smith" },
            { key: "email",  label: "Work Email",  placeholder: "jane@county.gov", type: "email" },
            { key: "county", label: "County",      placeholder: "Johnson County" },
            { key: "state",  label: "State",       placeholder: "Ohio" },
            { key: "title",  label: "Job Title",   placeholder: "Election Director" },
          ].map((f) => (
            <div key={f.key} style={{ gridColumn: f.key === "title" ? "1 / -1" : undefined }}>
              <label style={{
                display: "block",
                fontSize: 11,
                color: "var(--text-muted)",
                fontFamily: "var(--font-mono)",
                marginBottom: 5,
                letterSpacing: "0.05em",
              }}>
                {f.label.toUpperCase()}
              </label>
              <input
                type={f.type || "text"}
                placeholder={f.placeholder}
                value={lead[f.key] || ""}
                onChange={(e) => updateLead({ [f.key]: e.target.value })}
                className="input"
                required={f.key === "name" || f.key === "email"}
              />
            </div>
          ))}
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: "100%", padding: "13px" }}
          disabled={!lead.email || !lead.name}
        >
          Send My Report & Recommendations →
        </button>

        <p style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 10, textAlign: "center" }}>
          No spam. Your data is used only for your assessment follow-up.
        </p>
      </form>
    </div>
  );
}
